// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_fJ","advertDetailServiceList__header":"c-p_fK","advertDetailServiceList__list":"c-p_fL"};